import { namespace } from './saga';

export function selectAuthors(state) {
  return state.generic[namespace];
}
